import React from 'react';
import styles from './index.modules.less';
import cx from 'classnames';
import PropTypes from 'prop-types';

const TextView = (props) => {
  const { numberOfLines, style = {}, children, className, ...ext } = props;
  return (
    <div
      {...ext}
      className={cx(styles[`numberOfLines${numberOfLines}`], className)}
      style={{ ...style }}>
      {children}
    </div>
  );
};

TextView.defaultProps = {
  numberOfLines: 1,
  style: {},
  className: ''
};

TextView.propTypes = {
  // 多行文本溢出 数字1就超过1行的文本内容自动...
  numberOfLines: PropTypes.number,
  // 内联样式
  style: PropTypes.object,
  // class类 名
  className: PropTypes.string
};

export default TextView;



// WEBPACK FOOTER //
// ./src/components/Text/index.js